import { Drawer } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const FieldMappingStepDrawer = ({ open, setOpen }) => (
  <Drawer
    width={490}
    title="映射說明"
    open={open}
    onClose={() => setOpen(false)}
  >
    <div style={{ color: "#666" }}>
      <h4>
        <InfoCircleOutlined /> 欄位映射指南：
      </h4>
      <ul>
        <li>
          <strong>必填欄位：</strong>這些欄位是 SFR
          系統運作必須的，請確保都有正確映射
        </li>
        <li>
          <strong>資料表：</strong>ERP 系統中存放此欄位數據的資料表名稱
        </li>
        <li>
          <strong>欄位名稱：</strong>在該資料表中對應的欄位名稱
        </li>
        <li>
          <strong>JOIN 條件：</strong>如果需要關聯其他資料表，請填入 JOIN 條件
        </li>
        <li>
          <strong>轉換規則：</strong>如果 ERP 和 SFR
          的數據格式不同，可設定轉換規則
        </li>
      </ul>

      <h4>常見轉換範例：</h4>
      <ul>
        <li>
          <strong>狀態映射：</strong>ERP 的狀態碼 0→SFR 的狀態
          1（未開工→已創建）
        </li>
        <li>
          <strong>日期格式：</strong>ERP 的 'YYYY/MM/DD' → SFR 的 'YYYY-MM-DD
          HH:mm:ss'
        </li>
        <li>
          <strong>布林值：</strong>ERP 的 'Y'/'N' → SFR 的 true/false
        </li>
      </ul>
    </div>
  </Drawer>
);

export default FieldMappingStepDrawer;
